module.exports = __webpack_public_path__ + "static/media/frog(8).6db5c365.PNG";